// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1j4aN","errors":"Errors_errors__2hiGj"};